import React from 'react';
import { Button } from './ui/button';
import { Download, Star, Smartphone } from 'lucide-react';
import playIcon from './assets/play_icon.svg';

const DownloadCTA = () => {
  // const handleDownload = () => {
  //   //window.open('https://play.google.com/store/apps/details?id=com.mpointer.touchpad.bigphones', '_blank');
  //   gtag_report_conversion();
  // };

  return (
    <section id="download" className="py-20 sm:py-28 bg-gradient-to-br from-indigo-600 via-indigo-700 to-purple-700 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl animate-blob"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-300 rounded-full mix-blend-overlay filter blur-3xl animate-blob animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-pink-300 rounded-full mix-blend-overlay filter blur-3xl animate-blob animation-delay-4000"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-lg rounded-3xl flex items-center justify-center shadow-2xl animate-float">
              <Smartphone className="w-10 h-10 text-white" />
            </div>
          </div>

          {/* Headline */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
            Ready to Transform Your
            <span className="block mt-2">Mobile Experience?</span>
          </h2>

          {/* Description */}
          <p className="text-xl text-indigo-100 max-w-2xl mx-auto leading-relaxed">
            Join thousands of users who are already enjoying effortless one-handed control. Download now and experience the difference.
          </p>

          {/* Stats */}
          <div className="flex flex-wrap justify-center gap-8 py-6">
            <div className="text-center">
              <p className="!font-bold !text-4xl mb-1 text-white">1M+</p>
              <p className="text-indigo-200">Active Users</p>
            </div>
            <div className="w-px bg-white/20"></div>
            <div className="text-center">
              <div className="flex items-center justify-center mb-1">
                <p className="!font-bold !text-4xl text-white">4.2</p>
                <Star className="w-6 h-6 text-yellow-400 fill-yellow-400 ml-2" />
              </div>
              <p className="text-indigo-200">Play Store Rating</p>
            </div>
            <div className="w-px bg-white/20"></div>
            <div className="text-center">
              <p className="text-4xl font-bold text-white mb-1">100%</p>
              <p className="text-indigo-200">Free Forever</p>
            </div>
          </div>

          {/* CTA Button */}
          {/* <div className="flex flex-col sm:flex-row justify-center items-center gap-4 pt-4">
            <Button
              onClick={handleDownload}
              size="lg"
              className="bg-white text-indigo-600 hover:bg-gray-100 shadow-2xl hover:shadow-3xl transition-all text-lg px-10 py-7 group text-center min-w-[240px]">

              <Download className="w-5 h-5 mr-2 group-hover:animate-bounce" />
              Download Free Now
            </Button>
          </div> */}

          {/* Trust indicators */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6 text-indigo-200 text-sm pt-4">
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Easy to Use</span>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Highly Customizable</span>
            </div>
            <div className="flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Trusted & Secure</span>
            </div>
          </div>

          {/* Google Play Badge */}
          <div className="pt-4">
            <p className="text-indigo-200 text-sm mb-3">Available on</p>
            <div className="flex justify-center">
              <img
                src={playIcon}
                alt="Get it on Google Play"
                className="h-20" />
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default DownloadCTA;